import React from 'react';
import ReactDOM from 'react-dom';
import './styles/App.css';
import App from './App.js';

ReactDOM.render(<App />, document.getElementById('root'));